import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Icon from '../../modules/foundation/components/Icon/Icon';
var defaultProps = {
  className: '',
  iconName: ''
};
export default function Phone(_ref) {
  var phone = _ref.phone,
    className = _ref.className,
    iconName = _ref.iconName;
  if (_isEmpty(phone)) {
    return null;
  }
  function getContent() {
    if (!_isEmpty(iconName)) {
      return /*#__PURE__*/React.createElement(Icon, {
        iconName: iconName
      });
    }
    return phone;
  }
  return /*#__PURE__*/React.createElement("a", {
    className: className,
    href: "tel:".concat(phone)
  }, getContent());
}
Phone.defaultProps = defaultProps;